import { APIMethod, fetchData } from "@client";

export async function removeWorkTypeQuery(id) {
  return await fetchData(`/tags/${id}`, APIMethod.DELETE);
}
